// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"16992394","732":"8c5886dc"}[chunkId] + ".chunk.js";
};